<section class="mx-3 mb-3">
  <app-toast></app-toast>
  <div class="row">
    <div class="col-sm-12 col-lg-8 col-12 col-xl-8">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div class="d-flex align-items-center">
          <button mat-icon-button class="back_icon" (click)="closeClasses()">
            <i class="fa-solid fa-arrow-left"></i>
          </button>
          <h4 class="m-0 ps-2">
            <span>{{ classesData?.course_name }}</span> - <span>{{ classesData?.year }} Year</span>
            <span *ngIf="classesData?.section">,{{ classesData?.section }} Sec</span>
          </h4>
        </div>
        <div>
          <button mat-raised-button color="primary" class="submit_button" (click)="submitstudentattendance()"
            translate>Save</button>
        </div>
      </div>
      <!-- <div class="position-relative"> -->
      @if (isLoadingResults || isRateLimitReached) {
      <div class="loading-shade">
        @if (isLoadingResults) {
        <mat-spinner class="mat_spinner"></mat-spinner>
        }
        @if (isRateLimitReached) {
        <div class="rate-limit-reached" translate>
          GitHub's API rate limit has been reached. It will be reset in one minute.
        </div>
        }
      </div>
      }
      <div class="table-container">
        <mat-table [dataSource]="StudentList" style="max-height: 70vh;">
          <ng-container matColumnDef="select">
            <mat-header-cell *matHeaderCellDef>
              <!-- <mat-checkbox (change)="$event ? toggleAllRows() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
              </mat-checkbox> -->
              <div class="d-flex align-items-center" [matMenuTriggerFor]="menu">
                <span>Select</span>
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="toggleAllRows('PRESENT')" translate>Present</button>
                <button mat-menu-item (click)="toggleAllRows('ABSENT')" translate>Absent</button>
              </mat-menu>
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
              <mat-checkbox (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(row) && toggleStatus(row, $event.checked) : null"
                [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
              </mat-checkbox>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="id">
            <mat-header-cell *matHeaderCellDef translate> ID </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.student_id }} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef translate> Name </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.student_name }} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef translate> Status </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <!-- <mat-icon [ngClass]="{
                  absent: element.status == 'ABSENT',
                  present: element.status == 'Present'
                }" (click)="toggleStatus(element)" class="status-toggle">
                {{ element.status === 'ABSENT' ? 'toggle_off' : 'toggle_on' }}
              </mat-icon>
              <span class="status-text">{{element.status === 'ABSENT' ? 'Absent' : 'Present'}}</span> -->

              <mat-slide-toggle class="example-margin"
                (click)="toggleStatus(element, element.status === 'ABSENT' ? 'PRESENT' : 'ABSENT');selectioncheckbox(element)"
                [checked]="element.status == 'PRESENT'">
                <p class="status-text">{{element.status}}</p>
              </mat-slide-toggle>
            </mat-cell>
          </ng-container>

          <!-- <ng-container matColumnDef="tillDate">
            <mat-header-cell *matHeaderCellDef> Till Date % </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div class="progress-bar-container">
                <mat-progress-bar mode="determinate" [value]="element.tillDate" [ngClass]="{
                  'progress-red': element.tillDate < 50,
                  'progress-green': element.tillDate > 50
                }"></mat-progress-bar>
              </div>
              <span>{{ element.tillDate }}%</span>
            </mat-cell>
          </ng-container> -->

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          <mat-row *matNoDataRow>
            <mat-cell colspan="4" translate>No data</mat-cell>
          </mat-row>
        </mat-table>
      </div>
    </div>
    <div class="col-sm-12 col-lg-4 col-xl-4 col-12">
      <div>

        <mat-card class="class_attendance_card p-3">
          <h3 translate>Attendance Data</h3>
          @if(studentsattendancedetailschart?.presenteesPercentage > 0){
          <div class="d-flex justify-content-center align-items-center">
            <div class="chart-container">
              <canvas baseChart id="MyChart">{{ chart }}</canvas>
            </div>
          </div>
          <div class="donut-legend">
            <span class="legend-item">
              <span class="legend-color" style="background-color:#4CAF50"></span>
              Present
            </span>
            <span class="legend-item">
              <span class="legend-color" style="background-color:#F44336"></span>
              Absent
            </span>
          </div>
          } @else{
          <div class="no_data_container">
            <span translate>No Data Available</span>
          </div>
          }
        </mat-card>
        <mat-card class="class_attendance_card overflow_scrol p-3 mt-3">
          <h3 translate>Absentees Data</h3>
          @if(studentsattendancedetailschart?.absenteesPercentage > 0){
          <mat-list>
            <mat-list-item *ngFor="let item of absenteesData" class="list-item p-0">
              <span class="item-id">Ht.No: {{ item.student_id }}</span>
              <span class="item-name">{{ item.student_name }}</span>
              <span class="icon-container">
                <mat-icon class="icon" translate>comment</mat-icon>
              </span>
            </mat-list-item>
          </mat-list>
          } @else{
          <div class="no_data_container">
            <span translate>No Absentees</span>
          </div>
          }
        </mat-card>
      </div>
    </div>
  </div>
  <!-- </div> -->

</section>